import React from 'react';
import { Box } from '@mui/material';

const ORANGE = '#FF6900';

const pillSx = {
    display: 'flex', alignItems: 'center', padding: '9px 20px', borderRadius: '50px',
    border: '1.5px solid var(--brand-border, #ddd)', cursor: 'pointer',
    fontSize: '13px', fontWeight: 700, userSelect: 'none',
    color: 'var(--brand-text, #374151)', backgroundColor: 'var(--brand-surface, #fff)',
};

/**
 * "Enter manually / Upload …" at the top of an Add dialog — the same pair Add a
 * Class offers, so adding one account and uploading many start from the same
 * button (Ian, 8 Oct 2026).
 *
 * The Partner's dialogs call the pair "Add Manually / Import CSV" and show it on
 * BOTH screens, so the import can switch back to the form (LA-PW-07-Oct-03,
 * slides 10-12): `active` says which side this screen is.
 */
const EntryModeToggle = ({
    uploadLabel, manualLabel = 'Enter manually', active = 'manual', onUpload, onManual, centered = false,
}) => {
    const on = { ...pillSx, borderColor: ORANGE, color: '#fff', backgroundColor: ORANGE, cursor: 'default' };
    const off = { ...pillSx, '&:hover': { borderColor: ORANGE, color: ORANGE } };
    return (
        <Box sx={{ display: 'flex', gap: '10px', flexWrap: 'wrap', mb: 2, justifyContent: centered ? 'center' : 'flex-start' }}>
            <Box sx={active === 'manual' ? on : off} role="button" onClick={active === 'manual' ? undefined : onManual}>
                {manualLabel}
            </Box>
            <Box sx={active === 'upload' ? on : off} role="button" onClick={active === 'upload' ? undefined : onUpload}>
                {uploadLabel}
            </Box>
        </Box>
    );
};

export default EntryModeToggle;
